import { render, staticRenderFns } from "./FemaleSVG.vue?vue&type=template&id=0c17fc52&scoped=true&"
import script from "./FemaleSVG.vue?vue&type=script&lang=js&"
export * from "./FemaleSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17fc52",
  null
  
)

export default component.exports